'use client';

import Link from 'next/link';
import { useEffect, type MouseEvent, type ReactNode } from 'react';
import { trackAnalyticsEvent } from '@/lib/privacy/analytics-client';
import type { AnalyticsMetadata, HomepageAnalyticsEvent } from '@/lib/privacy/analytics-policy';

export const trackHomepageEvent = trackAnalyticsEvent;

export function HomepageAnalyticsView({ emptySections }: { emptySections: string[] }) {
  useEffect(() => {
    void trackHomepageEvent('home_page_view', {
      empty_section_count: emptySections.length,
    });
    emptySections.forEach((section) => {
      void trackHomepageEvent('home_section_empty', { section });
    });
  }, [emptySections]);

  return null;
}

export function TrackedHomeLink({
  href,
  className,
  children,
  eventType,
  metadata,
  onClick,
}: {
  href: string;
  className?: string;
  children: ReactNode;
  eventType: HomepageAnalyticsEvent;
  metadata?: AnalyticsMetadata;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}) {
  return (
    <Link
      href={href}
      className={className}
      onClick={(event) => {
        void trackHomepageEvent(eventType, { ...metadata, href });
        onClick?.(event);
      }}
    >
      {children}
    </Link>
  );
}
